import React from 'react';
import ErrorTemplate from '../ErrorTemplate';

class Error403 extends React.Component {
  render() {
    return (
      <div>     
     
         <ErrorTemplate
        errorCode="403"
        errorMessage="Forbidden Access"
      />
      </div>

    );
  }
}

export default Error403;